import { lazy } from 'react';

const BookingDetails = lazy(() => import('../components/BookingDetails'));
const BookingsList = lazy(() => import('../components/BookingsList'));
const Overview = lazy(() => import('../components/Overview'));
const Login = lazy(() => import('../components/Login'));
const FAQs = lazy(() => import('../components/FAQs'));
interface Route {
  path: string;
  exact?: boolean;
  component: React.FunctionComponent<any>;
}

type RoutesType = Array<Route>;

export const Routes: RoutesType = [
  {
    path: '/',
    exact: true,
    component: Overview,
  },
  {
    path: '/login',
    exact: true,
    component: Login,
  },
  {
    path: '/bookings',
    exact: true,
    component: BookingsList,
  },
  {
    path: '/booking/:requestId',
    exact: true,
    component: BookingDetails,
  },
  {
    path: '/faqs',
    exact: true,
    component: FAQs,
  },
];
